import { gql } from 'graphql-tag'

import { HOST_CARD_SESSION_HOST } from '@/components/Series/Banners/BreakoutSessionBanner/internal/HostCard.hasura'
import { REGISTRATION_CARD_SESSION_REGISTRATION } from '@/components/Series/Banners/BreakoutSessionBanner/internal/RegistrationCard.hasura'

export const BREAKOUT_SESSION_MANAGE_BANNER_SESSION = gql`
  fragment BreakoutSessionManageBannerSession on session {
    session_breakouts(order_by: { id: asc }) {
      id
      session_registrations {
        ...RegistrationCardSessionRegistration
      }
    }
    session_registrations(where: { session_breakout_id: { _is_null: true }, attempted_joining: { _eq: true } }) {
      ...RegistrationCardSessionRegistration
    }
    session_hosts(where: { attempted_hosting: { _eq: true } }) {
      ...HostCardSessionHost
    }
  }

  ${REGISTRATION_CARD_SESSION_REGISTRATION}
  ${HOST_CARD_SESSION_HOST}
`
